import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppContext } from '../../contexts/Storage';

/**
 * Component that tracks navigation and updates the navigation context
 * Should be placed inside the Router and AppWrapper
 */
const NavigationTracker: React.FC = () => {
  const location = useLocation();
  const { currentPage, setPreviousPage, setCurrentPage } = useAppContext();

  useEffect(() => {
    // Update navigation history whenever the location changes
    const newPage = location.pathname;
    
    if (currentPage && currentPage !== newPage) {
      setPreviousPage(currentPage);
    }
    setCurrentPage(newPage);
  }, [location.pathname, currentPage, setPreviousPage, setCurrentPage]);

  // This component doesn't render anything
  return null;
};

export default NavigationTracker;